import { render, staticRenderFns } from "./EditProductPage.vue?vue&type=template&id=4ac97c13"
import script from "./EditProductPage.vue?vue&type=script&lang=js"
export * from "./EditProductPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports